import React, { useState, useEffect } from 'react'
import { Link } from 'react-router-dom';
import { useNavigate } from "react-router-dom";
import { DataGrid, GridToolbar } from '@mui/x-data-grid'
import { TextField, Select, FormControl, MenuItem } from '@mui/material'
import Button from '@mui/material/Button';

import MuiDialogAlert from '../components/MuiDialogAlert';
import LoadingOverlay from 'react-loading-overlay-ts';

import { epochToHumanReadableTS, pretty_print_json } from '../components/Functions'

import axios from 'axios';
import AdminMenu from '../components/AdminMenu'

const columns_task_schedule = [
    { field: 'task_type', headerName: 'Type', width: 100 },
    { field: 'req', headerName: 'Request' },
    { field: 'interval', headerName: 'Interval' },
    { field: 'start_time', headerName: 'Start Time' },
    { field: 'end_time', headerName: 'End Time' },
    { field: 'last_exec_time', headerName: 'Last Exec Time', width: 200 },
    { field: 'active', headerName: 'Active', width: 100 }
]

const columns_wakeup_data = [
    { field: 'timestamp', headerName: 'Time Stamp', width: 200 },
    { field: 'msg_id', headerName: 'Msg ID' },
    { field: 'epoch', headerName: 'Epoch' },
    { field: 'data', headerName: 'Data', width: 300 },
    { field: 'return_msg', headerName: 'Return Data', width: 300 }
]

const columns_transactions_data = [
    { field: 'timestamp', headerName: 'Time Stamp', width: 200 },
    { field: 'epoch', headerName: 'Epoch' },
    { field: 'msg_id', headerName: 'Msg ID' },
    { field: 'req', headerName: 'Req' },
    { field: 'msg_no', headerName: 'Msg_NO' },
    { field: 'msg_cnt', headerName: 'Msg_CNT' },
    { field: 'data', headerName: 'DATA', width: 200 },
    { field: 'raw_msg', headerName: 'RAW', width: 200 }

]

const form_target_list = [
    "id",
    "device_id"
]

const default_form_vals = {
    "device_id":""
}


const AdminViewDevice = () => {
    let navigate = useNavigate();

    const [deviceList, setDeviceList] = useState([]);
    const [formData, setFormData] = useState(default_form_vals)
    const [deviceData, setDeviceData] = useState({
        "task_schedule": [],
        "device_wakeup": [],
        "transactions": []
    })
    const [loadingActive, setLoadingActive] = useState(false);
    const [loadingText, setLoadingText] = useState("Loading");

    const [modalHeader, setModalHeader] = useState("");
    const [modalBody, setModalBody] = useState("");
    const [modalHtml, setModalHtml] = useState("");
    const [showModal, setShowModal] = useState(false);    
    
    const handleClose = () => setShowModal(false);

    // Start up : Load the list of available devices
    useEffect(() => {
        const getDevices = async () => {
            try {
                // Make a GET request using Axios
                let url = process.env.REACT_APP_API_SERVER + "/getDevices";
                console.log(`URL: ${url}`);
                const response = await axios.get(url, {
                    params: {
                        "api_user": JSON.parse(localStorage.getItem('user'))
                    }
                });

                if (response.data.status === "API_AUTH_ERROR") {
                    // Force user to re-login if unable to autheticate with the API
                    navigate("/logout")
                }

                console.log(response.data);
                // Set the retrieved data to the state
                setDeviceList(response.data);
                updateFormData("device_id", response.data[0].device_id)
            } catch (error) {
                // Handle errors if the request fails
                console.log(error);
                // setError(error);
               
            }
        };

        // Call the fetchData function when the component mounts

        setLoadingActive(true);
        getDevices();
        setLoadingActive(false);


    }, [])

    useEffect(() => {
        console.log("Device ID change")

        if (formData.device_id != ""){
            let url = process.env.REACT_APP_API_SERVER + "/adminDeviceInfo";
            let post_data = {
                "device_id" : formData.device_id
            }
            setLoadingActive(true)
            axios.post(url, post_data)
                .then(function (response) {
                    let data = response.data;
                    console.log(data)

                    let device_wakeup = data.device_wakeup
                    let device_wakeup_data = []

                    device_wakeup.map((row) => {
                        let tmp_json = {}
                        tmp_json.id = row.id
                        tmp_json.epoch = row.epoch
                        tmp_json.timestamp = epochToHumanReadableTS(row.epoch)
                        tmp_json.msg_id = row.msg_id
                        tmp_json.data = JSON.stringify(row.data)
                        tmp_json.return_msg = JSON.stringify(row.return_msg)
                        device_wakeup_data.push(tmp_json)
                    });

                    let transactions = data.transactions
                    let transactions_data = []

                    transactions.map((row) => {
                        let tmp_json = {}
                        tmp_json.id = row.id
                        tmp_json.epoch = row.epoch
                        tmp_json.timestamp = epochToHumanReadableTS(row.epoch)
                        tmp_json.msg_id = row.msg_id
                        tmp_json.msg_no = row.msg_no
                        tmp_json.msg_cnt = row.msg_cnt
                        tmp_json.req = row.req
                        tmp_json.data = JSON.stringify(row.data)
                        tmp_json.raw_msg = JSON.stringify(row.raw_msg)
                        transactions_data.push(tmp_json)
                    });


                    data.device_wakeup = device_wakeup_data
                    data.transactions = transactions_data
                    setDeviceData(data)

                    
                })
                .catch(function (error) {
                    setModalHeader("Error")
                    setModalBody(error)
                    setShowModal(true)
                });       
            setLoadingActive(false)
 
        }    

    },[formData.device_id])

    function updateForm(e) {
        console.log(e)

        if (form_target_list.includes(e.target.id)) {
            console.log("id")
            console.log(e.target.id)
            console.log(e.target.value)
            updateFormData(e.target.id, e.target.value)
        }

        if (form_target_list.includes(e.target.name)) {
            console.log("name");
            console.log(e.target.name)
            console.log(e.target.value)
            updateFormData(e.target.name, e.target.value)
        }
        return

    }

    function updateFormData(id, val) {
        setFormData((prevFormData) => ({
            ...prevFormData,
            [id]: val,
        }));
    }

    function wakeUpDataRowClick(e) {
        console.log(e)

        let data_json = e.row.data
        let return_msg_json = e.row.return_msg

        let tmp_html = `
        <div><b>Msg ID</b></div>
        <div>${e.row.msg_id}</div>
        <div><b>Data</b></div>
        <div>
        <pre>${pretty_print_json(data_json)}</pre>
        </div>
        <div><b>Return Msg</b></div>
        <div>
        <pre>${pretty_print_json(return_msg_json)}</pre>
        </div>
        
        `
        console.log(tmp_html)
        setModalHeader(e.row.timestamp)
        setModalHtml(tmp_html)
        setShowModal(true)

    }

    function transactionsDataRowClick(e) {
        console.log(e)

        let data_json = e.row.data
        let raw_msg_json = e.row.raw_msg

        let tmp_html = `
        <div><b>Msg ID</b></div>
        <div>${e.row.msg_id}</div>
        <div><b>Data</b></div>
        <div>
        <pre>${pretty_print_json(data_json)}</pre>
        </div>
        <div><b>Raw Msg</b></div>
        <div>
        <pre>${pretty_print_json(raw_msg_json)}</pre>
        </div>
        
        `
        console.log(tmp_html)
        setModalHeader(e.row.timestamp)
        setModalHtml(tmp_html)
        setShowModal(true)

    }


    return (
        <div align="left" style={{ height: "100%", padding: "30px" }} className='admin_pages'>
            <LoadingOverlay
                active={loadingActive}
                spinner
                text={loadingText}
                className="spinner_div"
            >

                <AdminMenu />
                <div>
                    <div class="container">

                        <div class="row">

                            {/* Drop down menu to select device  */}
                            <div class="col-md-12">
                                <table width="100%">
                                    <tr>
                                        <td>
                                            <div className="form-labels-admin">Select Device</div>
                                            <FormControl fullWidth>
                                                <Select
                                                    id="device_id"
                                                    name="device_id"
                                                    label="Select Device"
                                                    value={formData.device_id}
                                                    variant="outlined"
                                                    onChange={updateForm}
                                                    sx={{
                                                        '& legend': { display: 'none' },
                                                        '& fieldset': { top: 0 },
                                                        ' & .MuiSelect-select': { fontSize: 14 }
                                                    }}
                                                >
                                                    {
                                                        deviceList.map(device => {
                                                            return <MenuItem key={device.device_id} value={device.device_id}>
                                                                {device.device_id}
                                                            </MenuItem>
                                                        })
                                                    }
                                                </Select>
                                            </FormControl>
                                        </td>
                                    </tr>
                                </table>
                                <div style={{ height: "20px" }}></div>
                            </div>

                            {/* Settings */}
                            <div class="col-md-6"> 
                                <div className='class_0'>Settings</div>
                                {
                                    deviceData.devices && 
                                    <table>
                                        <tr>
                                            <td className='class_1'>Device ID</td>
                                            <td className='class_2'>{deviceData.devices[0].device_id}</td>
                                        </tr>
                                        <tr>
                                            <td className='class_1'>Description</td>
                                            <td className='class_2'>{deviceData.devices[0].settings.description}</td>
                                        </tr>
                                        <tr>
                                            <td className='class_1'>Address</td>
                                            <td className='class_2'>{deviceData.devices[0].settings.address}</td>
                                        </tr>
                                        <tr>
                                            <td className='class_1'>Latitude</td>
                                            <td className='class_2'>{deviceData.devices[0].settings.latitude}</td>
                                        </tr>
                                        <tr>
                                            <td className='class_1'>Longitude</td>
                                            <td className='class_2'>{deviceData.devices[0].settings.longitude}</td>
                                        </tr>
                                        <tr>
                                            <td className='class_1'>Bin Min Value</td>
                                            <td className='class_2'>{deviceData.devices[0].settings.bin_max_min[0].bin_min}mm</td>
                                        </tr>
                                        <tr>
                                            <td className='class_1'>Bin Max Value</td>
                                            <td className='class_2'>{deviceData.devices[0].settings.bin_max_min[0].bin_max}mm</td>
                                        </tr>
                                        <tr>
                                            <td className='class_1'>Active</td>
                                            <td className='class_2'>{(deviceData.devices[0].active) ? "TRUE" : "FALSE"}</td>
                                        </tr>
                                    </table>
                                }
                                <div style={{ height: "20px" }}></div>
                                <div className='class_0'>Status</div>
                                {
                                    deviceData.devices &&
                                <table>
                                    <tr>
                                        <td className='class_1' valign="top">Last Wakeup</td>
                                        <td className='class_2'>{epochToHumanReadableTS(deviceData.devices[0].status.sleep_status.last_wakeup)}</td>
                                    </tr>
                                    <tr>
                                        <td className='class_1' valign="top">Next Wakeup</td>
                                        <td className='class_2'>{epochToHumanReadableTS(deviceData.devices[0].status.sleep_status.next_wakeup)}</td>
                                    </tr>
                                    <tr>
                                        <td className='class_1' valign="top">Alert Status</td>
                                        <td className='class_2'>
                                            <div className='class_3'>Current Alert</div>
                                            <div className='class_4'>{deviceData.devices[0].status.alert_status.alert_status.current_alert}</div>
                                            <div className='class_3'>Last Update (Epoch)</div>
                                            <div className='class_4'>{deviceData.devices[0].status.alert_status.alert_status.alert_epoch}</div>
                                            <div className='class_3'>Last Update (Timestamp)</div>
                                            <div className='class_4'>{deviceData.devices[0].status.alert_status.alert_status.alert_timestamp}</div>                                            
                                        </td>
                                    </tr>

                                </table>
                                }
                            </div>
                            {/* Status */}
                            <div class="col-md-6">
                                <div className='class_0'>Last Reading</div>
                                {
                                    deviceData.devices &&
                                    <table>
                                        <tr>
                                            <td className='class_1' valign="top">VOLUME</td>
                                            <td className='class_2'>
                                                <div className='class_3'>Vol Height</div>
                                                <div className='class_4'>{deviceData.devices[0].status.latest_transaction.VOLUME.vol_height}mm</div>
                                                <div className='class_3'>Vol Percent</div>
                                                <div className='class_4'>{deviceData.devices[0].status.latest_transaction.VOLUME.vol_percent}%</div>
                                                <div className='class_3'>Vol Last Update (Epoch)</div>
                                                <div className='class_4'>{deviceData.devices[0].status.latest_transaction.VOLUME.vol_update_epoch}</div>
                                                <div className='class_3'>Vol Last Update (Timestamp)</div>
                                                <div className='class_4'>{deviceData.devices[0].status.latest_transaction.VOLUME.vol_update_timestamp}</div>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td className='class_1' valign="top">BATTERY</td>
                                            <td className='class_2'>
                                                <div className='class_3'>Battery Level (ADC)</div>
                                                <div className='class_4'>{deviceData.devices[0].status.latest_transaction.BATTERY.batt_adc}</div>
                                                <div className='class_3'>Battery Level (%)</div>
                                                <div className='class_4'>{deviceData.devices[0].status.latest_transaction.BATTERY.batt_percent}%</div>
                                                <div className='class_3'>Batt Last Update (Epoch)</div>
                                                <div className='class_4'>{deviceData.devices[0].status.latest_transaction.BATTERY.batt_update_epoch}</div>
                                                <div className='class_3'>Batt Last Update (Timestamp)</div>
                                                <div className='class_4'>{deviceData.devices[0].status.latest_transaction.BATTERY.batt_update_timestamp}</div>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td className='class_1' valign="top">TEMPERATURE</td>
                                            <td className='class_2'>
                                                <div className='class_3'>Temperature (°C)</div>
                                                <div className='class_4'>{deviceData.devices[0].status.latest_transaction.TEMPERATURE.temperature}°C</div>
                                                <div className='class_3'>Temperature Last Update (Epoch)</div>
                                                <div className='class_4'>{deviceData.devices[0].status.latest_transaction.TEMPERATURE.temp_update_epoch}</div>
                                                <div className='class_3'>Temperature Last Update (Timestamp)</div>
                                                <div className='class_4'>{deviceData.devices[0].status.latest_transaction.TEMPERATURE.temp_update_timestamp}</div>
                                            </td>
                                        </tr>
                                    </table>
                                }


                            </div>
                            {/* Task Schedule */}
                            <div class="col-md-12">
                                <div style={{ height: "20px" }}></div>
                                <div className='class_0'>Task Schedule</div>
                                <div style={{ height: 400, width: 1200 }}>
                                    <DataGrid
                                        rows={deviceData.task_schedule}
                                        columns={columns_task_schedule}
                                        pageSize={50}
                                        disableVirtualization
                                        disableSelectionOnClick
                                        components={{ Toolbar: GridToolbar }}
                                        sx={{
                                            '& .MuiTablePagination-selectLabel': {
                                                paddingTop: '15px'

                                            },
                                            '& .MuiTablePagination-displayedRows': { paddingTop: '15px' },
                                            '& .MuiDataGrid-cell': { fontSize: 12 },
                                            '& .MuiDataGrid-columnHeader': { fontSize: 12 },
                                            '& .MuiDataGrid-cell:focus, & .MuiDataGrid-cell--editing': {
                                                outline: 'none', // Remove outline when cell is focused or editing
                                                border: 'none', // Remove border when cell is focused or editing
                                            }

                                        }} />
                                </div>
                                <div style={{ height: "20px" }}></div>
                            </div>
                            {/* Wake Up */}
                            <div class="col-md-12">
                                <div className='class_0'>Wake Up</div>
                                <div style={{ height: 600, width: 1200 }}>
                                    <DataGrid
                                        rows={deviceData.device_wakeup}
                                        columns={columns_wakeup_data}
                                        pageSize={50}
                                        onRowClick={wakeUpDataRowClick}
                                        disableVirtualization
                                        disableSelectionOnClick
                                        components={{ Toolbar: GridToolbar }}
                                        sx={{
                                            '& .MuiTablePagination-selectLabel': {
                                                paddingTop: '15px'

                                            },
                                            '& .MuiTablePagination-displayedRows': { paddingTop: '15px' },
                                            '& .MuiDataGrid-cell': { fontSize: 12 },
                                            '& .MuiDataGrid-columnHeader': { fontSize: 12 },
                                            '& .MuiDataGrid-cell:focus, & .MuiDataGrid-cell--editing': {
                                                outline: 'none', // Remove outline when cell is focused or editing
                                                border: 'none', // Remove border when cell is focused or editing
                                            }

                                        }} />
                                </div>
                                <div style={{ height: "20px" }}></div>
                            </div>
                            {/* Transactions */}
                            <div class="col-md-12">
                                <div className='class_0'>Transactions</div>
                                <div style={{ height: 600, width: 1200 }}>
                                    <DataGrid
                                        rows={deviceData.transactions}
                                        columns={columns_transactions_data}
                                        pageSize={50}
                                        onRowClick={transactionsDataRowClick}
                                        disableVirtualization
                                        disableSelectionOnClick
                                        components={{ Toolbar: GridToolbar }}
                                        sx={{
                                            '& .MuiTablePagination-selectLabel': {
                                                paddingTop: '15px'

                                            },
                                            '& .MuiTablePagination-displayedRows': { paddingTop: '15px' },
                                            '& .MuiDataGrid-cell': { fontSize: 12 },
                                            '& .MuiDataGrid-columnHeader': { fontSize: 12 },
                                            '& .MuiDataGrid-cell:focus, & .MuiDataGrid-cell--editing': {
                                                outline: 'none', // Remove outline when cell is focused or editing
                                                border: 'none', // Remove border when cell is focused or editing
                                            }

                                        }} />
                                </div>
                                <div style={{ height: "20px" }}></div>
                            </div>
                        </div>
                    </div>

                </div>

                <MuiDialogAlert
                    showModal={showModal}
                    handleClose={handleClose}
                    html={modalHtml}
                    bodyContent={modalBody}
                    title={modalHeader}
                    bodyClass="whitespace"
                />


            </LoadingOverlay>
        </div>
    )
}

export default AdminViewDevice